import React from "react";
import { useTranslation } from "react-i18next";
import { Search, Plus, Inbox } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

export function PageToolbar({ search, onSearch, filters, primaryAction, rightExtra, testid }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-3 mb-5" data-testid={testid}>
      <div className="relative flex-1 min-w-[240px] max-w-md">
        <Search size={16} strokeWidth={1.75} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-mediumGrey pointer-events-none" />
        <Input
          data-testid={`${testid}-search`}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={t("common.search")}
          className="pl-9 bg-white"
        />
      </div>
      <div className="flex items-center gap-2">{filters}</div>
      <div className="flex-1" />
      {primaryAction}
      {rightExtra}
    </div>
  );
}

export function PrimaryAddButton({ onClick, label, testid }) {
  return (
    <Button
      onClick={onClick}
      className="bg-brand-red hover:bg-[#a50d25] text-white shadow-sm transition-colors"
      data-testid={testid}
    >
      <Plus size={16} strokeWidth={2} className="mr-1.5" />
      {label}
    </Button>
  );
}

export function DataTable({ columns, rows, onRowDoubleClick, emptyText, testid }) {
  if (!rows || rows.length === 0) {
    return (
      <div
        className="bg-white border border-brand-lightGrey rounded-2xl px-10 py-16 text-center"
        data-testid={`${testid}-empty`}
      >
        <div className="mx-auto h-12 w-12 rounded-full bg-brand-softNavy flex items-center justify-center text-brand-lightNavy">
          <Inbox size={22} strokeWidth={1.75} />
        </div>
        <p className="mt-4 text-sm text-brand-mediumGrey">{emptyText}</p>
      </div>
    );
  }
  return (
    <div className="bg-white border border-brand-lightGrey rounded-2xl overflow-hidden shadow-sm" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-brand-offWhite border-b border-brand-lightGrey">
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  className={`px-5 py-3 text-left text-[11px] uppercase tracking-[0.08em] text-brand-mediumGrey font-semibold ${c.thClass || ""}`}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-lightGrey/70">
            {rows.map((r) => (
              <tr
                key={r.id}
                data-testid={`${testid}-row-${r.id}`}
                className="hover:bg-brand-softNavy/40 cursor-pointer transition-colors"
                onDoubleClick={() => onRowDoubleClick?.(r)}
              >
                {columns.map((c) => (
                  <td key={c.key} className={`px-5 py-3.5 align-middle text-brand-darkGrey ${c.tdClass || ""}`}>
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
